import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoService } from 'src/app/services/pedido.service';

@Component({
  selector: 'app-cod-finame-modal',
  templateUrl: './cod-finame-modal.component.html',
  styleUrls: ['./cod-finame-modal.component.scss']
})
export class CodFinameModalComponent implements OnInit {

  idCupom: any;
  codFiname: any;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(public dialogRef: MatDialogRef<CodFinameModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService, private pedidoService: PedidoService) {
    this.idCupom = data.idCupom;
    this.codFiname = data.codFiname;
  }

  ngOnInit(): void {
  }

  salvar() {
    this.carregandoService.mostra('salvar');    
    this.pedidoService.atualizarCodigoFiname(this.idCupom, this.codFiname).subscribe((data: any) => {
      this.dialogRef.close(this.codFiname);      
      this.carregandoService.esconde('salvar');
    }, (erro) => {
      this.carregandoService.esconde('salvar');
      this.notificacaoService.erro(erro);
    });

  }

  fechar() {
    this.dialogRef.close();
  }

}
